<template>
  <div>
    <template v-for="(termo, i) in getModalsExibir()">
      <v-dialog
        v-model="termo.exibir"
        :key="i"
        scrollable
        persistent
        max-width="1050"
        :fullscreen="isMobile()"
        :retain-focus="false"
      >
        <v-card color="grey lighten-3">
          <v-card-title class="primary white--text">
            {{ termo.descricao }}
          </v-card-title>
          <v-card-subtitle v-if="termo.versao != ''" class="primary white--text"
            >Versão: {{ termo.versao }}</v-card-subtitle
          >
          <v-card-text class="pt-3 pl-2 pr-2">
            <!-- Exibir documento HTML para rescisão indireta (tipo 22) -->
            <div v-if="termo.idtipodoc == 22" class="text-center pa-4">
              <v-btn color="primary" large @click="abrirDocumentoHtml(termo)">
                <v-icon left>mdi-open-in-new</v-icon>
                Abrir Documento de Rescisão
              </v-btn>
              <p class="mt-3 text-caption">
                O documento será aberto em uma nova aba do navegador
              </p>
            </div>
            <!-- Exibir PDF para outros tipos de documentos -->
            <vue-pdf-embed
              v-else
              :source="getLinkPdf(termo.id, termo.idtipodoc)"
              :page="1"
              style="width: 100%"
            />
          </v-card-text>
          <v-card-actions>
            <v-row dense>
              <v-col cols="12">
                <v-card flat class="transparent">
                  <v-card-text class="pt-1">
                    <v-checkbox hide-details="" v-model="aceiteTermos[i]">
                      <template v-slot:label>
                        <span class="black--text"
                          >Declaro que li e concordo com os termos descritos
                          acima</span
                        >
                      </template>
                    </v-checkbox>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-btn
                  block
                  color="success"
                  rounded
                  :loading="loading"
                  :disabled="!aceiteTermos[i]"
                  @click="confirmarTermos(termo.id, termo.idtipodoc)"
                  class="mb-2"
                  >Confirmar</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>

<script>
import { getToken, getCoordenadas } from "@/global";
import axios from "axios";
import VuePdfEmbed from "vue-pdf-embed/dist/vue2-pdf-embed";
import { mapState } from "vuex";

export default {
  components: {
    VuePdfEmbed,
  },
  computed: {
    ...mapState("usuario", ["pendencias"]),
  },
  data: () => ({
    loading: false,
    aceiteTermos: [],
    dialogs: [],
    localizacao: "",
    docs: [],
  }),
  methods: {
    getLinkPdf(id, idtipodoc) {
      return `${
        process.env.VUE_APP_BASE_URL
      }/colaborador/pendencias-colaborador?token=${getToken()}&funcao=EXIBIR-DOC&id=${id}&tipodoc=${idtipodoc}`;
    },
    getLinkHtml(id) {
      // Usar a mesma URL que o admin web usa para exibir documentos HTML
      return `${
        process.env.VUE_APP_BASE_URL
      }/colaborador/documentos?token=${getToken()}&funcao=EXIBIR&doc=${id}&colaborador=${
        this.$store.state.usuario.usuarioLogado?.codIdFeder || ""
      }`;
    },
    fecharModal(ind) {
      this.docs.splice(ind, 1);
    },
    getModalsExibir() {
      if (this.docs.length > 0) return this.docs.filter((t) => t.exibir);
      return [];
    },
    isMobile() {
      return this.$mq == "sm";
    },
    async abrirDocumentoHtml(termo) {
      const url = this.getLinkHtml(termo.id, termo.idtipodoc);
      window.open(url, "_blank");
    },
    async confirmarTermos(id, tipodoc) {
      this.loading = true;
      var ipAddress = await axios.get("https://api.ipify.org/");
      var logConfirmacao = `IP:${ipAddress.data}`;

      try {
        var position = await getCoordenadas();
      } catch (error) {
        console.log(error);
      }

      if (position) {
        logConfirmacao += ` | Latitude: ${position.coords.latitude} | Longitude: ${position.coords.longitude}`;
      }

      await axios
        .post(
          `/colaborador/pendencias-colaborador?funcao=CONFIRMAR-TERMOS&id=${id}&tipodoc=${tipodoc}`,
          JSON.stringify({
            confirmacao: logConfirmacao,
          })
        )
        .then((res) => {
          if (res.data.success) {
            this.$router.go();
          } else this.$toasted.error(res.data.msg);
        })
        .catch((e) => this.$toasted.error(e))
        .finally(() => {
          this.loading = false;
        });
    },
  },

  async created() {
    if (this.pendencias) {
      this.docs = this.pendencias.documentos;

      if (this.docs.length > 0) {
        for (let index = 0; index < this.docs.length; index++) {
          this.docs[index].exibir = true;
          this.aceiteTermos[index] = false;
        }
      }
    }
  },
};
</script>

<style></style>
